import { UserIdentity, UserIdToFullNameRequest } from '@blk/aw-bff-typescript-models';
import { AxiosResponse, CancelToken } from 'axios';
import { awBffApi } from './Base';

export interface UserIdToFullNameMapParams {
  cancelToken?: CancelToken;
  userIdToFullNameRequest: UserIdToFullNameRequest;
}

export const userIdentityPath = '/user';
export function getUser(): Promise<AxiosResponse<UserIdentity>> {
  return awBffApi.get<UserIdentity>(userIdentityPath);
}

export function postUserIdToFullNameMap(
  params: UserIdToFullNameMapParams
): Promise<AxiosResponse<{ [originalId: string]: string }>> {
  const { cancelToken, userIdToFullNameRequest } = params;
  const path = '/user/userid-to-fullname-map';
  return awBffApi.post<{ [originalId: string]: string }>(path, userIdToFullNameRequest, {
    cancelToken,
  });
}
